<template>
    <div>
        <h1>Some day I'll dream...</h1>
    </div>
</template>

<script>
export default {
    name: 'Blog'
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Blog.vue